export default __webpack_public_path__ + "static/media/kucoin.17096774.svg";